module.exports = "/build/web/svg/play-circle-outline.15b29cb1ae585c6f9a68c03aa088d596.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/play-circle-outline.svg
// module id = 177
// module chunks = 24